import { createIcon } from "@chakra-ui/react";

export const Hamburger = createIcon({
  displayName: "Hamburger",
  viewBox: "0 0 24 24",
  d: "M4.174 5.974c0-.655.5-1.185 1.118-1.185h13.416c.618 0 1.118.53 1.118 1.185s-.5 1.184-1.118 1.184H5.292c-.619 0-1.118-.53-1.118-1.184zm0 5.92c0-.654.5-1.184 1.118-1.184h13.416c.618 0 1.118.53 1.118 1.185s-.5 1.184-1.118 1.184H5.292c-.619 0-1.118-.53-1.118-1.184zm15.652 5.922c0 .655-.5 1.184-1.118 1.184H5.292c-.619 0-1.118-.53-1.118-1.184 0-.655.5-1.184 1.118-1.184h13.416c.618 0 1.118.529 1.118 1.184z",
  defaultProps: {
    "aria-label": "Three lines stacked vertically"
  }
});

export default Hamburger;

